/** @module user/dashboard/card */

import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { changeItemsPerPage, changeOrderAndOrderBy } from '#action/user/users-paginated';
import PreloaderComponent from '#component/preloader';
import NotFoundMessage from '#component/general/not-found-message';
import propTypes from './prop-types';
import MobileCard from './mobile-card';

const DEFAULT_ITEMS_PER_PAGE = 20;
const DEFAULT_ORDER = 'asc';
const DEFAULT_ORDER_BY = 'firstName';

/**
 * Renders card with user name
 * and devices related to this user.
 * Contains button to edit user info.
 *
 * @function UsersCardView
 * @param {*} props
 * @returns {React.Fragment}
 */

const UsersCardView = props => {
  const { users } = props;
  const dispatch = useDispatch();
  const {
    status,
    order,
    orderBy,
    itemsPerPage
  } = useSelector(s => s.usersPaginated, shallowEqual);
  const loading = ['loading', 'idle'].includes(status);

  useEffect(() => {
    if (itemsPerPage !== DEFAULT_ITEMS_PER_PAGE) {
      dispatch(changeItemsPerPage(DEFAULT_ITEMS_PER_PAGE));
    }
    if (order !== DEFAULT_ORDER || orderBy !== DEFAULT_ORDER_BY) {
      dispatch(changeOrderAndOrderBy(DEFAULT_ORDER, DEFAULT_ORDER_BY));
    }
  }, [dispatch, itemsPerPage, order, orderBy]);

  if (!users.length && loading) {
    return <PreloaderComponent />;
  }

  if (!users.length && !loading) {
    return (
      <NotFoundMessage style={{ marginTop: -50 }}>
        No users
      </NotFoundMessage>
    );
  }

  return (
    loading ? <PreloaderComponent /> :
      users.map(user => (
        <MobileCard
          user={user}
          key={user.id}
        />
      ))
  );
};

export default UsersCardView;

UsersCardView.propTypes = propTypes;
